import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Loader2 } from 'lucide-react';
import MysteryBoxPage from './MysteryBoxPage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// BAÚ MISTERIOSO — página própria do evento (como OIL TYCOON, Roleta, Balões): só cliente logado.
export default function MysteryBoxEventPage() {
  const navigate = useNavigate();
  const [kakoId, setKakoId] = useState(null);
  const [erro, setErro] = useState('');

  useEffect(() => {
    const tok = localStorage.getItem('customer_token');
    if (!tok) { navigate('/conta', { replace: true }); return; }
    axios.get(`${API}/customer-auth/me`, { headers: { Authorization: `Bearer ${tok}` } })
      .then((r) => setKakoId(r.data.kako_id))
      .catch((e) => {
        if (e.response?.status === 401) { localStorage.removeItem('customer_token'); navigate('/conta', { replace: true }); return; }
        setErro('Não consegui carregar sua conta. Tente de novo.');
      });
  }, [navigate]);

  return (
    <div className="relative min-h-screen bg-[#1a0b3a]" data-testid="mystery-event-page">
      <style>{'.mb-safe-anchor { top: max(env(safe-area-inset-top), 28px); }'}</style>
      <button onClick={() => navigate('/conta')} data-testid="mystery-back"
        className="mb-safe-anchor fixed left-3 z-40 flex items-center gap-1 rounded-full border border-purple-400/50 bg-black/55 px-3 py-1.5 text-xs font-bold text-purple-100 backdrop-blur transition-transform active:scale-95">
        <ArrowLeft className="h-4 w-4" /> Minha conta
      </button>
      {erro && <p className="pt-24 text-center text-sm text-rose-300" data-testid="mystery-error">{erro}</p>}
      {!erro && !kakoId && (
        <div className="flex min-h-screen items-center justify-center text-purple-200" data-testid="mystery-loading"><Loader2 className="h-8 w-8 animate-spin" /></div>
      )}
      {kakoId && <div className="pt-[max(env(safe-area-inset-top),20px)]"><MysteryBoxPage kakoId={kakoId} /></div>}
    </div>
  );
}
